// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"ada78bb7","322":"a8c0469b"}[chunkId] + ".chunk.css";
};